/**
 * @module lib/election/error-state
 * @description Initializes an error state for election features
 */
import tgamConfig from "config/tgam";
import { qs } from "utils/utils";

/**
 * @method errorStateHideFeature
 * @description Hide the current feature when no data is returned
 * @param {HTMLElement} feature - the selected feature to hide when no data is returned
 */
export function errorStateHideFeature(feature) {
  feature && feature.classList.add("u-hidden");
}

/**
 * @method errorStateShowFeature
 * @description Show the current feature when data is returned
 * @param {HTMLElement} feature - the selected feature to show when no data is returned
 */
export function errorStateShowFeature(feature) {
  feature && feature.classList.remove("u-hidden");
}

/**
 * @method errorStateOverlayEnabled
 * @description Show the error state overlay on the current feature when no data is returned
 * @param {HTMLElement} feature - the selected feature to overlay when no data is returned
 */
export function errorStateOverlayEnabled(feature) {
  const featureEl = qs(feature);
  if (!featureEl) {
    return;
  }
  featureEl.classList.add("c-election-error-wrapper");
  const errorMessage = tgamConfig.env.electionErrorStateMessage;
  const errorOverlay = `<div class="c-election-error">
    <svg class="c-election-error__art" role="img" pointer-events="none" focusable="false" aria-hidden="true">
      <use xlink:href="${tgamConfig.env.svgSpritePath}#icon-error" class="c-election-error__use"></use>
    </svg>
    <span class="c-election-error__content">${errorMessage}</span>
  </div>`;
  const errorExists = qs(`${feature} > .c-election-error`);
  if (!errorExists) {
    featureEl.insertAdjacentHTML("afterbegin", errorOverlay);
  }
}

/**
 * @method errorStateOverlayDisabled
 * @description Hide the error state overlay on the current feature when data is returned
 * @param {HTMLElement} feature - the selected feature to remove the overlay from when data is returned
 */
export function errorStateOverlayDisabled(feature) {
  const featureEl = qs(feature);
  if (!featureEl) {
    return;
  }
  const featureErrorEl = qs(`${feature} > .c-election-error`);
  featureEl.classList.remove("c-election-error-wrapper");
  if (featureErrorEl) {
    featureErrorEl.parentNode.removeChild(featureErrorEl);
  }
}
